import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { getLanguageNameFromCode } from '../../../utils/langUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const TranslateTemplateFieldGroupLabel = styled.span.withConfig({
  displayName: "TranslateTemplateTextFieldGroup__TranslateTemplateFieldGroupLabel",
  componentId: "sc-1bi4jaw-0"
})(["font-size:16px;font-weight:600;"]);
export default function TranslateTemplateTextFieldGroup(props) {
  return /*#__PURE__*/_jsx(UIAccordionItem, {
    className: "m-top-4",
    title: /*#__PURE__*/_jsx(TranslateTemplateFieldGroupLabel, {
      children: props.title
    }),
    children: props.languages.map((lang, idx) => {
      const isPrimary = idx === 0;
      const onChange = e => props.onChange(lang, e.target.value);
      const value = props.values.get(lang, '');
      return /*#__PURE__*/_jsx(UIFormControl, {
        verticalSeparation: "flush",
        label: getLanguageNameFromCode(lang),
        labelTooltip: isPrimary ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.templateEditor.translateModal.primaryLanguageFieldTooltip"
        }) : null,
        children: /*#__PURE__*/_jsx(UITextInput, {
          readOnly: isPrimary,
          onChange: onChange,
          value: value || ''
        })
      }, lang);
    })
  });
}